export const contactsData = {
    email: 'nusrathjahan58@gmail.com',
    phone: '(+46)767480143',
    address: '1118,2B Laboratorgrand 93162 Skelleftea, Sweden',

    sheetAPI: ''
}